// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-logo{padding-bottom:7px;cursor:pointer}.common-header{display:flex;top:0;align-items:center;justify-content:space-between;height:80px;font-size:16px;padding:0 30px;cursor:default;box-shadow:0 5px 16px 0 rgba(3,58,138,.08);z-index:100;position:relative;background-color:#fff}.common-header.qq-style{flex-shrink:0}", ""]);
// Exports
module.exports = exports;
